module.exports = __webpack_public_path__ + "static/img/IR showroom.2ac919be.svg";